<form [formGroup]="form">
  <div class="col-12 divCheck">
    <p class="textoRadio">Autorizar</p>
    <mat-radio-group
      class="formRadio"
      formControlName="autorizar"
      aria-label="Select an option"
    >
      <mat-radio-button value="Si">Si</mat-radio-button>
      <mat-radio-button style="margin-left: 10px" value="No"
        >No</mat-radio-button
      >
    </mat-radio-group>
  </div>
  <div class="col-12 divCheck">
    <p class="textoRadio">Patron de fraude</p>
    <mat-radio-group
      class="formRadio"
      formControlName="patron_fraude"
      aria-label="Select an option"
    >
      <mat-radio-button value="Si">Si</mat-radio-button>
      <mat-radio-button style="margin-left: 10px" value="No"
        >No</mat-radio-button
      >
    </mat-radio-group>
  </div>
</form>
